<template>
  <div>
    <upload-list
      v-if="showTitle()"
      v-show="!($refs.upload && $refs.upload.dropActive)
      "
      :pendency="pendency"
    />
    <div
      v-if="showInput()"
      class="file-upload "
      :class="{'min-height': $refs.upload && $refs.upload.dropActive}"
    >
      <div class="upload">
        <template v-if="!hasFiles()">
          <div class="cta">
            <img
              src="/static/images/icon-upload.svg"
              alt="icon-drag-and-drop"
            >
            <img
              src="/static/images/icon-upload-hover.svg"
              alt="icon-drag-and-drop"
              class="hover"
            >
            <h4>Arraste e solte o arquivo aqui</h4>
            <p>ou</p>
          </div>
          <div
            v-show="$refs.upload && $refs.upload.dropActive"
            class="drop-active"
          >
            <img
              src="/static/images/drag-drop.svg"
              alt="icon-drag-and-drop"
            >
            <h3>Solte aqui</h3>
          </div>
          <div class="upload-btn">
            <file-upload
              ref="uploadPendency"
              v-model="files"
              post-action="/upload/post"
              :multiple="true"
              :drop="true"
              :drop-directory="true"
              input-id="pendency"
            >
              SELECIONE O ARQUIVO
            </file-upload>
          </div>
        </template>
        <template v-if="hasFiles()">
          <div class="upload-btn-plus">
            <file-upload
              ref="uploadPendency"
              v-model="files"
              post-action="/upload/post"
              :multiple="true"
              :drop="true"
              :drop-directory="true"
              input-id="pendency"
            >
              <img
                class="hover"
                src="/static/images/upload-plus-hover-icon.svg"
                alt="icon-drag-and-drop"
              >
              <img
                src="/static/images/upload-plus-icon.svg"
                alt="icon-drag-and-drop"
              >
            </file-upload>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
import UploadList from './PendenciesUploadList'
import FileUpload from 'vue-upload-component'
export default {
  components: {
    UploadList,
    FileUpload
  },
  props: {
    pendency: {
      type: Object,
      default: {}
    }
  },
  data: () => ({
    files: []
  }),
  computed: {
    ...mapGetters(['uploadLimit', 'pendencyUploadStatus']),
    dragActive () {
      if (this.$refs.upload && this.$refs.upload.dropActive) return true
      return false
    }
  },
  watch: {
    files: function (val, old) {
      let input = val.filter(a => !old.map(b => b.id).includes(a.id))
      input.forEach(element => {
        if (!element.uuid) {
          this.uploadDocumentPendency({
            file: element,
            pendencyId: this.pendency.id,
            length: input.length
          })
        }
      })
    },
    pendency: function (val) {
      if (val.files) {
        this.files = val.files
      } else {
        this.files = []
      }
    }
  },
  methods: {
    ...mapActions(['uploadDocumentPendency']),
    hasFiles () {
      if (this.pendency && this.pendency.files) {
        let files = this.pendency.files
        if (files.length > 0) return true
      }
      return false
    },
    showTitle () {
      const files = this.pendency.files
      const status = this.pendency.status
      if (files) {
        if (status === 'R' && files.length === 0) return false
      }
      return true
    },
    showInput () {
      if (this.pendencyUploadStatus === 'UPLOAD_ERROR') return false
      const files = this.pendency.files
      if (files) {
        for (let file in files) {
          if (file.error) return false
        }
      }
      if (this.pendency.status === 'R') return false
      if (files && files.length >= this.uploadLimit) return false
      return true
    }
  }
}
</script>
<style lang="scss">
.file-upload {
  border: 1px dashed #7e898a;
  box-sizing: border-box;
  border-radius: 7px !important;
  padding: 20px;
  position: relative;
  margin-top: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  &.min-height {
    min-height: 150px;
  }
  &:hover {
    border-color: #7f1a54;
    background-color: #efeaed;
    .upload {
      .cta {
        img {
          display: none
        }
        .hover {
          display: block;
          margin: 0 auto;
        }
        h4 {
          color: #4A4A4A;
        }
        p {
          color: #4A4A4A;
        }
      }
      .upload-btn-plus {
        span {
          position: initial;
        }
        .file-uploads {
          .hover {
            display: block;
            & + img {
              display: none;
            }
          }
        }
      }
    }
  }
  .upload {
    text-align: center;
    .cta {
      .hover {
        display: none;
      }
      h4 {
        color: #9B9B9B;
        font-weight: normal;
        margin: 5px 0 0px;
        font-size: 15px;
      }
      p {
        font-size: 12px;
        color: #9B9B9B;
        line-height: 1;
        margin: 2px 0 7px;
        text-align: center;
      }
    }
    .upload-btn {
      .file-uploads {
        cursor: pointer;
        background-color: transparent;
        border: 1px  solid #7F1A54;
        color: #7F1A54;
        padding: 5px 20px;
        height: auto;
        border-radius: 5px;
        font-weight: 500;
        letter-spacing: 1.3px;
        &:hover {
          background-color: #7f1a54;
          color: #ffffff;
        }
        label {
          cursor: pointer;
        }
      }
    }
    .upload-btn-plus {
      .file-uploads {
        display: flex;
        align-items: center;
        justify-content: center;
        .hover {
          display: none;
        }
      }
    }
  }
  .drop-active {
    top: -1px;
    bottom: -1px;
    right: -1px;
    left: -1px;
    position: absolute;
    z-index: 9999;
    text-align: center;
    background: #efeaed;
    border: 1px dashed #7F1A54;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-wrap: wrap;
    flex-direction: column;
    border-radius: 7px !important;
    h3 {
      color: #4A4A4A;
      font-size: 16px;
      margin: 10px 0 0;
    }
  }
}
label[for='file'] {
  cursor: pointer;
}
</style>
